// extracted by mini-css-extract-plugin
export default {"fullCenter":"BusinessProfilePage_fullCenter__9Eizx","container":"BusinessProfilePage_container__ToKV1"};